<template>
    <div id="map" class="h-full w-full">

    </div>
</template>

<script setup lang="ts">
import 'maplibre-gl/dist/maplibre-gl.css'
import { Map, ScaleControl, NavigationControl, type LngLatLike, Marker, setRTLTextPlugin, LngLatBounds } from 'maplibre-gl'
import { useGlobalStore } from '~/stores/global'

interface MarkerInput {
    lngLat: LngLatLike
    color?: string
}

const props = withDefaults(defineProps<{
    center: LngLatLike
    controls?: boolean
    scrollZoomDisabled?: boolean
    markers?: MarkerInput[]
    fitBounds?: boolean
    dark?: boolean
}>(), { dark: true })

const global = useGlobalStore()
const config = useRuntimeConfig()

const map = ref<Map>()
const mapLoaded = ref(false)

onMounted(() => {
    if (!global.mapRtlPluginLoaded) {
        global.mapRtlPluginLoaded = true
        setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js', true)
    }

    map.value = new Map({
        container: 'map',
        style: `https://api.maptiler.com/maps/${props.dark ? 'streets-v2-dark' : 'streets-v2'}/style.json?key=${config.public.maptilerKey}`,
        center: props.center,
        zoom: 15,
        attributionControl: false,
    }).on('load', onMapLoaded)
})

function onMapLoaded() {
    mapLoaded.value = true
    if (!map.value) return

    if (props.scrollZoomDisabled) {
        map.value.scrollZoom.disable()
    }

    if (props.controls) {
        map.value.addControl(new ScaleControl({}), 'bottom-right')
        map.value.addControl(new NavigationControl({}), 'top-right')
    }

    if (props.markers && props.markers.length > 0) {
        for (const m of props.markers) {
            new Marker({ color: m.color }).setLngLat(m.lngLat).addTo(map.value)
        }
        if (props.fitBounds && props.markers.length >= 2) {
            const bounds = new LngLatBounds()
            for (const m of props.markers) bounds.extend(m.lngLat)
            map.value.fitBounds(bounds, { padding: 48, duration: 0, maxZoom: 14 })
        }
    } else {
        new Marker().setLngLat(props.center).addTo(map.value)
    }
}
</script>
